import { forwardRef } from 'react';
import type { HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

export interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * Accessible label for screen readers. Skeletons are decorative by default.
   */
  'aria-label'?: string;
}

/**
 * Renders an animated placeholder that should reuse the exact dimensions of its resolved counterpart.
 */
export const Skeleton = forwardRef<HTMLDivElement, SkeletonProps>(function Skeleton(
  { className, 'aria-label': ariaLabel, ...rest },
  ref,
) {
  const hasAccessibleLabel = typeof ariaLabel === 'string' && ariaLabel.trim().length > 0;

  return (
    <div
      ref={ref}
      role={hasAccessibleLabel ? 'img' : undefined}
      aria-label={hasAccessibleLabel ? ariaLabel : undefined}
      aria-live="polite"
      className={twMerge('animate-pulse rounded-xl bg-surface-subtle/70', className)}
      {...rest}
    />
  );
});
